import { Component, OnInit } from '@angular/core';
import { VernostServiceService } from "../../services/vernost-service.service";
import { Papa } from 'ngx-papaparse';
import { saveAs } from "file-saver";
import { ToastrService } from "ngx-toastr";



@Component({
  selector: 'app-conv-fee-tpm',
  templateUrl: './conv-fee-tpm.component.html',
  styleUrls: ['./conv-fee-tpm.component.css'],
  providers: [Papa]
})
export class ConvFeeTpmComponent implements OnInit {

  actionmode: string = "Seacrh";
  showList: boolean = false;
  showSearch: boolean = false;
  fname = "";
  lname = "";
  uid = "";
  noresult = "";
  loader = false;
  screentitle: string = "Conv-Fee-tpm";
  count = 1;
  recordId = 0;
  tableArray: any = [];
  jsonData: any = [];
  screen_details: any = [];
  search_details: any = [];
  search_Record: any = [];
  EditRecord: any = [];
  EditRecord1: any = [];
  Cabindetails: any = [{ type: "B", name: "Business" }, { type: "E", name: "Economy" }];
  Segment_details: any = [{ name: "Oneway" }, { name: "Round" }];


  Journey_details: any = [{ type: "I", name: "International" }, { type: "D", name: "Domestic" }];
  constructor(private papa: Papa, private vernostService: VernostServiceService, private toastr: ToastrService) { }


  ngOnInit() {
    this.clearTable();

    this.fname = localStorage.getItem("fname");
    this.lname = localStorage.getItem("lname");
    this.uid = localStorage.getItem('uid');
    this.search_details.jounrney = "0";
    this.search_details.cabin = "0";
    this.search_details.segment = "0";

  }

  addForm() {
    this.actionmode = "Add";
    this.showList = false;
    this.clearALl();
    this.clearTable();
  }

  searchForm() {
    this.actionmode = "Search";
    this.showSearch = false;
  }

  Add() {
    this.count = this.count + 1;
    this.tableArray.push({ id: this.count });

  }

  Delete(id) {

    //(document.getElementById("class+1") as HTMLInputElement).st;
    if (this.tableArray.length > 1) {
      (document.getElementById("r" + id) as HTMLInputElement).remove();
      this.tableArray.forEach((element, i) => {
        if (element.id == id) {
          this.tableArray.splice(i, 1);
        }


      });
    }
    console.log("here=", this.tableArray);
  }


  searchData() {
    this.showSearch = true;
    var jounrney = this.search_details.jounrney;
    var srange = this.search_details.srange;
    var erange = this.search_details.erange;
    var cabin = this.search_details.cabin;
    var segment = this.search_details.segment;
    var obj = { jounrney: jounrney, srange: srange, erange: erange, cabin: cabin, segment: segment }
    this.vernostService.searchConvData(obj).subscribe(response => {
      if (response["result"] != undefined) {
        if (response["result"].length > 0) {
          this.search_Record = response["result"];
          this.search_Record.forEach(element => {
            if (element.TPM_JOURNEY_TYPE == "I") {
              element.TPM_JOURNEY_CODE = "International";
            } else {
              element.TPM_JOURNEY_CODE = "Domestic";
            }

            if (element.TPM_CABIN_CLASS == "E") {
              element.TPM_CABIN_CLASS_CODE = "Economy"
            } else {
              element.TPM_CABIN_CLASS_CODE = "Business"
            }

          });
          console.log("rr=", JSON.stringify(this.search_Record));

        } else {

          this.toastr.error(" Result Not Found ");
          this.showSearch = false;
        }
      }

    })

  }


  openfileDialog() {
    document.getElementById("fileLoader").click();
  }



  test = [];
  fileChangeListener(evt) {
    this.loader = true;
    var files = evt.target.files; // FileList object
    var file = files[0];
    if (this.vernostService.isCSVFile(files[0])) {
      var reader = new FileReader();
      reader.readAsText(file);
      reader.onload = (event: any) => {
        var csv = event.target.result;
        console.log("file=>", event.target.result)
        this.papa.parse(csv, {
          skipEmptyLines: true,
          header: true,
          complete: (results) => {
            for (let i = 0; i < results.data.length; i++) {
              let orderDetails = {
                order_id: results.data[i].Address,
                age: results.data[i].Age
              };
              this.test.push(orderDetails);
            }
            // console.log(this.test);
            console.log("K=", JSON.stringify(results.data.length));
            this.jsonData = results.data;
            var record = this.addUserInfo(this.jsonData);
            if (record.status) {
              console.log("length=", record.data);
              var obj = { result: record.data };
              // 
              var isvalid = this.validateCSV(results.data);
              if (isvalid) {
                this.vernostService.uploadConvData(obj).subscribe(response => {
                  this.loader = false;
                  evt.target.value = "";
                  console.log("here=", response);
                  if (response["status"]) {
                    this.toastr.success(response["msg"]);
                    this.clearTable();
                    this.clearALl();
                  } else {
                    this.toastr.error(response["msg"]);
                    console.log("error");
                    evt.target.value = "";
                  }

                })
              } else {
                this.toastr.error("Invalid Convenience Fee")
                evt.target.value = "";
                this.loader = false;

              }
            } else {
              this.toastr.error("Invalid Record");
            }



          }
        });
      }
    } else {
      this.toastr.error("Please import valid .csv file");
      this.loader = false;
      evt.target.value = "";
    }
  }

  validateCSV(data) {
    for (let i = 0; i < data.length; i++) {
      var regx = /^[1-9]\d*(\.\d+)?$/;
      var isCorrect = regx.test(data[i].CONVIENIENCE_FEE);
      if (!isCorrect) {
        console.log("-->", data[i].TPM_ID);
        return false;
      }
    }
    return true;
  }


  addUserInfo(data) {
    data.forEach(element => {

      element.MODIFIED_BY = this.uid;

    });
    return ({ status: true, data: data });
  }

  Download() {
    this.loader = true;
    var url = "downloadConvData"
    var data = {};

    this.vernostService.DownloadReports(url, data).subscribe(
      result => {
        this.loader = false;
        // console.log("result",result.size);
        this.noresult = "";
        if (result.size != 0) {



          saveAs(result, "CON_FEE_TPM.csv");
        } else {
          this.noresult = "Result Not Found";
        }
        this.loader = false;
      },
      err => { }
    );
  }



  showFormData(tpmId, flag, obj) {
    console.log("b obj=", obj);
    this.recordId = tpmId;
    this.EditRecord = [];
    this.EditRecord.push(obj);
    this.EditRecord1 = this.search_Record.filter(data => (data.TPM_ID == obj.TPM_ID));
    console.log("this.EditRecord1", JSON.stringify(this.EditRecord1));

    console.log("A iii=", this.EditRecord);
    if (flag == 1) {

      console.log(JSON.stringify(this.EditRecord));
    } else {

      this.actionmode = 'Edit';
      this.clearALl();
      this.tableArray = [];
      this.count = 0;
      //  this.EditRecord.forEach(element => {
      //   this.count= this.count+1;
      //   this.tableArray.push({ id:this.count});
      //  });
      // setTimeout(data=>{this.tableArray.forEach((element,i) => {

      //   (document.getElementById("class"+ element.id) as HTMLInputElement).value=this.EditRecord[i].TPM_CABIN_CLASS;
      //   (document.getElementById("st"+ element.id) as HTMLInputElement).value=this.EditRecord[i].TPM_START_TIME;
      //   (document.getElementById("et"+element.id) as HTMLInputElement).value=this.EditRecord[i].TPM_END_TIME;
      //   (document.getElementById("cf"+element.id) as HTMLInputElement).value=this.EditRecord[i].CONVIENIENCE_FEE;

      //   (document.getElementById("sg"+element.id) as HTMLInputElement).value=this.EditRecord[i].SEGMENT;
      //   (document.getElementById("rpm"+element.id) as HTMLInputElement).value=this.EditRecord[i].RPM;
      //   (document.getElementById("pm"+element.id) as HTMLInputElement).value=this.EditRecord[i].PLOUGHBACK_MULTIPLIER;
      // });
      // },100);
      console.log("obj=", JSON.stringify(obj));
      this.screen_details.jounrney = this.EditRecord[0].TPM_JOURNEY_TYPE;
      this.screen_details.srange = this.EditRecord[0].TPM_START_RANGE;
      this.screen_details.erange = this.EditRecord[0].TPM_END_RANGE;
      //  this.screen_details.min=this.EditRecord[0].JP_MIN_MILES;
      //  this.screen_details.max=this.EditRecord[0].JP_MAX_MILES;

      this.screen_details.segmentDetails = this.EditRecord[0].SEGMENT;
      this.screen_details.convienienceFee = this.EditRecord[0].CONVIENIENCE_FEE;
      this.screen_details.endT = this.EditRecord[0].TPM_END_TIME;
      this.screen_details.startT = this.EditRecord[0].TPM_START_TIME;
      this.screen_details.Cabindetails = this.EditRecord[0].TPM_CABIN_CLASS;



    }

  }

  submitData() {
    this.loader = true;
    var journeyType = this.screen_details.jounrney;
    var startRange = this.screen_details.srange;
    var endRange = this.screen_details.erange;


    var segment = this.screen_details.segmentDetails;
    var conFee = this.screen_details.convienienceFee;
    var endT = this.screen_details.endT;
    var startT = this.screen_details.startT;
    var cabinClass = this.screen_details.Cabindetails;

    // var min=this.screen_details.min;
    // var max=this.screen_details.max;
    // var data=[];
    // this.tableArray.forEach(element => {
    //   var cabinClass=(document.getElementById("class"+element.id) as HTMLInputElement).value;
    //   var startTime=(document.getElementById("st"+element.id) as HTMLInputElement).value;
    //   var endTime=(document.getElementById("et"+element.id) as HTMLInputElement).value;
    //   var conFee=(document.getElementById("cf"+element.id) as HTMLInputElement).value;
    //   var segment=(document.getElementById("sg"+element.id) as HTMLInputElement).value;
    //   var rpm=(document.getElementById("rpm"+element.id) as HTMLInputElement).value;
    //   var multiplier=(document.getElementById("pm"+element.id) as HTMLInputElement).value;
    //   data.push({cabinClass:cabinClass,startTime:startTime,endTime:endTime,conFee:conFee,segment:segment,rpm:rpm,multiplier:multiplier});   
    //   });

    var modifiedBy = this.uid;
    console.log("modifiedBy:", modifiedBy);
    var obj = { recordId: this.recordId, journeyType: journeyType, startRange: startRange, endRange: endRange, min: "", max: "", segment: segment, conFee: conFee, endT: endT, startT: startT, cabinClass: cabinClass, modifiedBy: modifiedBy }
    console.log("DATA=", JSON.stringify(obj));
    if (this.actionmode == "Add") {
      this.vernostService.insertConvData(obj).subscribe(response => {
        this.loader = false;
        if (response["status"]) {
          alert("record Inserted");
          this.clearTable();
          this.clearALl();
        } else {
          console.log("error");
        }

      })

    } else {

      console.log("obj==", obj);
      this.vernostService.editConvData(obj).subscribe(response => {
        this.loader = false;
        if (response["status"]) {

          //  alert("Record Updated Successfully"); 
          this.toastr.success("Record Updated Successfully");
        } else {
          console.log("error");
        }

      })

    }



  }


  clearTable() {

    this.count = 1;
    this.tableArray = [];
    this.tableArray.push({ id: this.count });

  }
  clearALl() {
    this.screen_details.jounrney = "";
    this.screen_details.srange = "";
    this.screen_details.erange = "";
  }

  isNumberKey(evt: any) {
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    //	console.log("charCode === ", charCode);
    if (charCode == 190) {
      var txt = (<HTMLInputElement>document.getElementById(evt.target.id)).value;

      if ((txt.indexOf(".") >= -1))
        return true;
    }

    if (charCode > 46 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    if (charCode == 32) {
      return false;
    }
    return true;
  }
}
